import { createReducer, on } from '@ngrx/store';

import { HiddenMarketActions } from '../hidden-market.actions';
import { defaultHiddenMarketState } from '../hidden-market.state';

export const hiddenMarketReducer = createReducer(
    defaultHiddenMarketState,
    on(HiddenMarketActions.setHasPlacedFirstBet, (state, _) => {
        return {
            ...state,
            hasPlacedFirstBet: true,
        };
    }),
);
